var render, staticRenderFns
import script from "./bigthanks.vue?vue&type=script&lang=js"
export * from "./bigthanks.vue?vue&type=script&lang=js"
import style0 from "./bigthanks.vue?vue&type=style&index=0&id=7ad7564e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ad7564e",
  null
  
)

export default component.exports